import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable, Subject } from 'rxjs';
import { filter, map, takeUntil, tap } from 'rxjs/operators';

import { userQuery } from '@amfam/shared/user';
import { Agent, agentQuery } from '@amfam/shared/utility/agent';
import { BrandSelectors } from '@amfam/shared/utility/brand';
import { CopyService } from '@amfam/shared/utility/shared-services';

import * as fromRoot from '../../../core/store';

@Component({
  selector: 'agents-overview',
  templateUrl: './agents-overview.component.html',
  standalone: false
})
export class AgentsOverviewComponent implements OnInit, OnDestroy {
  agents = new Array<Agent>();
  dataLoading: Observable<boolean>;
  isCustomer: Observable<boolean>;
  dataLoaded: Observable<boolean>;
  spinnerText = 'Looking for agents...';
  sectionHeading = 'Agent info';
  defaultContactNumber;
  private stop$ = new Subject<void>();

  constructor(
    private store: Store,
    private copyService: CopyService
  ) {}

  ngOnInit() {
    this.dataLoading = this.store.select(agentQuery.getAgentsLoading);
    this.dataLoaded = this.store.select(agentQuery.getAgentsLoaded);
    this.isCustomer = this.store.select(userQuery.selectIsCustomer);
    this.defaultContactNumber = this.copyService.getCopy('shared.contactNumber');

    combineLatest(
      this.store.select(BrandSelectors.selectIsPartner),
      this.store.select(fromRoot.getAllActiveAgents),
      this.dataLoaded
    )
      .pipe(
        map(([isPartner, agents, loaded]) => ({
          isPartner: isPartner,
          agents: agents,
          loaded: loaded
        })),
        filter(state => state.loaded),
        takeUntil(this.stop$),
        tap(state => {
          this.agents = state.agents || new Array<Agent>();
          if (state.isPartner) {
            this.spinnerText = 'Looking for representative...';
            this.sectionHeading = 'My Representative';
          } else if (this.agents.length === 1) {
            this.sectionHeading = 'Agent info';
          } else if (this.agents.length > 1) {
            this.sectionHeading = 'Agents info';
          }
        })
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.stop$.next();
    this.stop$.complete();
  }
}
